module.exports = {
  baseURL: 'https://gateway.cqvantai.com',
}
